/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CancellationRevokeResponse interface.
 */
export function instanceOfCancellationRevokeResponse(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function CancellationRevokeResponseFromJSON(json) {
    return CancellationRevokeResponseFromJSONTyped(json, false);
}
export function CancellationRevokeResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': json['status'],
    };
}
export function CancellationRevokeResponseToJSON(json) {
    return CancellationRevokeResponseToJSONTyped(json, false);
}
export function CancellationRevokeResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': value['status'],
    };
}
